import { useEffect, useRef, useState } from "react";
import {
  Constants,
  MenuItems,
  pageRouteConstants,
} from "../../constants/constants";
import ProfileImage2 from "../../assets/images/profile2.svg";
import Button from "../common/cta/Button";
import { readFromLocalStorage } from "../../utils/DataEncryption";
import HamburgerIcon from "../../assets/images/HamburgerIcon";
import ProfileImage from "../../assets/images/profile.svg";
import NotificationIconInHeader from "../../assets/images/NotificationIconInHeader";
import SearchIconInHeader from "../../assets/images/SearcgIconInHeader";
import { componentMap, sideMenuIndexData } from "../common/SideMenu";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { updateIndex } from "../../store/slices/sideMenuSlice";
import { AppDispatch, RootState } from "../../store/store";
import SideMenuMobile from "../common/SideMenuMobile";
import { resetKey } from "../../store/slices/staffListSlice";
import { useTranslation } from "react-i18next";

/* 🔹 NEW ICONS (same as Web) */
import NumberOfBranchesIcon from "../../assets/images/NumberOfBranchesIcon";
import DealerShipNameIcon from "../../assets/images/DealerShipNameIcon";
import DealerShipNDealerShipNameIconForMobile from "../../assets/images/DealerShipNameIconForMobile";
import NumberOfBranchesIconForMobile from "../../assets/images/NumberOfBranchesIconForMobile";

export interface Role {
  name: string;
  department: string;
  group: string;
}

export interface RoleItem {
  role: Role;
  specializations: any[];
}

const MobileResponsiveHeader = ({
  handleLogout,
  setLogout,
  isLogout,
}: {
  handleLogout: () => void;
  setLogout: (val: boolean) => void;
  isLogout: boolean;
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sliderOpen, setSliderOpen] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(0);

  const sideMenuIndex = useSelector(
    (state: RootState) => state.sideMenuDetails.index
  );

  const menuRef = useRef<any>(null);
  const navigate = useNavigate();

  /* DATA */
  const storedBaseRolesParsed: RoleItem[] = JSON.parse(
    readFromLocalStorage("baseRoles") || "[]"
  );

  const application = JSON.parse(readFromLocalStorage("applications") || "[]");

  const hideLogoutButton =
    Array.isArray(application) &&
    application.some((app: string) =>
      ["salesmate-app", "salesmate-asa-app"].includes(app)
    );

  const userName = readFromLocalStorage("userName") ?? "Dealer";
  const dealerId = readFromLocalStorage("dealerId") ?? "";
  const dealershipName = readFromLocalStorage("dealershipName") ?? "";
  const branches: string[] = JSON.parse(
    readFromLocalStorage("branches") || "[]"
  );

  /* NAVIGATION */
  const handleClick = (index: number) => {
    switch (index) {
      case 0:
        navigate(pageRouteConstants.dashBoardRoute);
        break;
      case 1:
        navigate(pageRouteConstants.staffListRoute);
        break;
      case 5:
        navigate(pageRouteConstants.locationMaster);
        break;
      case 6:
        navigate(pageRouteConstants.helpRoute);
        break;
      default:
        navigate(pageRouteConstants.comingSoonRoute);
    }
    setSliderOpen(false);
  };

  useEffect(() => {
    let index = sideMenuIndex;
    if (sideMenuIndexData[window.location.hash] !== undefined) {
      index = sideMenuIndexData[window.location.hash];
    }
    setSelectedMenu(index);
    handleClick(index);
  }, [sideMenuIndex]);

  const handleChange = (index: number) => {
    dispatch(updateIndex(index));
    dispatch(resetKey());
    handleClick(index);
  };

  useEffect(() => {
    if (menuRef?.current) {
      menuRef.current.style.width = sliderOpen ? "256px" : "81px";
    }
  }, [sliderOpen]);

  return (
    <>
      <div className="border-b-white shadow-lg">
        <div className="bg-primary text-white w-full px-4 py-4 flex flex-col gap-3 shadow-md">
          {/* 🔹 TOP BAR */}
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-2">
              {!sliderOpen && (
                <button onClick={() => setSliderOpen(true)}>
                  <HamburgerIcon />
                </button>
              )}
              <img height="12" width="32" alt="ProfileImg" src={ProfileImage} />
            </div>

            <div className="flex items-center gap-4">
              <NotificationIconInHeader />
              <SearchIconInHeader />
              {!hideLogoutButton && (
                <button onClick={() => setLogout(!isLogout)}>
                  <img
                    height="40"
                    width="40"
                    alt="ProfileImg"
                    src={ProfileImage2}
                  />
                </button>
              )}
            </div>
          </div>

          {/* 🔹 USER INFO */}
          <div className="font-poppins overflow-hidden">
            {/* Welcome + Name */}
            <div className="flex items-center gap-1 consentSubmitButton truncate">
              <span>{t("Welcome")},</span>
              <span className="text-white">{userName}</span>
             
            </div>

            {/* Roles */}
            {storedBaseRolesParsed.length > 0 && (
              <div className="headerDealerDetails text-gray-200 truncate">
                {storedBaseRolesParsed
                  .map((roleItem) => roleItem?.role?.name ?? "Dealer")
                  .join(", ")}
              </div>
            )}

            {/* Dealer Details */}
            <div className="mt-1 flex flex-col gap-1 text-xs text-gray-200">
            {/* <div className="inline-flex items-center  border border-White bg-whiteColor rounded-lg p-2">
  <DealerShipNameIcon />
  <span className="headerDealerDetails text-primary pl-1 truncate">
    {dealershipName}
  </span>
</div> */}


              {/* Dealer ID + Branches (SINGLE ROW) */}
              <div className="flex items-center  gap-2">
                {/* Dealer ID */}
                <div className="truncate">
                  <span className="headerDealerDetails">Dealer ID:</span> {dealerId}
                </div>

                {/* Branches */}
                <div className="flex items-center gap-1 truncate">
                  <NumberOfBranchesIconForMobile />
                  <span className="headerDealerDetails whitespace-nowrap pl-1">
                    {branches.length} branches
                  </span>
                </div>

              </div>
              <div className="inline-flex items-center  border border-White bg-whiteColor rounded-lg p-2">
  <DealerShipNameIcon />
  <span className="headerDealerDetails text-primary pl-1 truncate">
    {dealershipName}
  </span>
</div>
            </div>
          </div>
        </div>

        {/* 🔹 SIDE MENU */}
        {sliderOpen && (
          <div className="absolute top-0 left-0 w-full h-full z-50">
            <SideMenuMobile
              menuItems={MenuItems}
              selectedMenuIndex={selectedMenu}
              componentMap={componentMap}
              openModal={() => setIsModalOpen(true)}
              closeModal={() => setIsModalOpen(false)}
              isSlideerOpen={sliderOpen}
              openSlider={() => setSliderOpen(true)}
              closeSlider={() => setSliderOpen(false)}
              handleChange={handleChange}
              isModalOpen={isModalOpen}
              menuRef={menuRef}
            />
          </div>
        )}

        {/* 🔹 LOGOUT */}
        {isLogout && (
          <div className="z-10 fixed top-[90px] right-0 p-2 bg-white shadow-2xl w-[200px] h-[200px] rounded-lg">
            <Button
              handleClick={handleLogout}
              buttonText={t("Logout")}
              className="bg-primary ml-6 mt-5 text-white px-8 py-2 rounded-md"
            />
          </div>
        )}
      </div>
    </>
  );
};

export default MobileResponsiveHeader;
